export * from './lib/features-photo-carousel.module';
export * from './lib/photo-carousel/photo-carousel.component';
export * from './lib/photo-carousel-modal/photo-carousel-modal.component';
